module.exports = __webpack_public_path__ + "static/media/home-horizontal.2486feba.png";